import React, { useEffect, useState } from "react";
import axios from "axios";

const GalleryCard = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [galleries, setGalleries] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedCaption, setSelectedCaption] = useState('');

    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_GALLERY;

        const cachedGalleries = localStorage.getItem("galleries");
        const cacheTimestamp = localStorage.getItem("galleriesTimestamp");

        if (cachedGalleries && cacheTimestamp && (Date.now() - cacheTimestamp < cacheExpiryTime)) {
            setGalleries(JSON.parse(cachedGalleries));
        } else {
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setGalleries(response.data);
                    localStorage.setItem("galleries", JSON.stringify(response.data));
                    localStorage.setItem("galleriesTimestamp", Date.now().toString());
                })
                .catch(error => console.error("Error fetching API", error));
        }
    }, []);

    // Updated Modal inline styles for proper image fitting
    const styles = {
        modalOverlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.85)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            padding: '20px'
        },
        modalContent: {
            position: 'relative',
            maxWidth: '850px',
            width: '100%',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            alignItem: 'center',
            background: '#ffffff',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
        },
        imageWrapper: {
            width: '100%',
            maxHeight: '75vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#000',
            overflow: 'hidden'
        },
        modalImage: {
            maxWidth: '100%',
            maxHeight: '75vh',
            objectFit: 'contain',
            display: 'block'
        },
        closeButton: {
            position: 'absolute',
            top: '12px',
            right: '12px',
            fontSize: '24px',
            color: '#fff',
            background: 'rgba(0, 0, 0, 0.6)',
            borderRadius: '50%',
            width: '36px',
            height: '36px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            zIndex: 10,
            transition: 'background 0.2s'
        }
    };

    return (
        <>
            <section className="team-area pt-80 pb-80">
                <div className="container">
                    {/* Section Title */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <h2 className="fw-bold mb-2" style={{ color: '#0f172a' }}>Our Members</h2>
                            <div className="divider" style={{ width: '30px', height: '4px', backgroundColor: '#2563eb', borderRadius: '2px' }}></div>
                        </div>
                    </div>

                    <div className="row white-color inner-team g-4">
                        {galleries.map((gallery, index) => (
                            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                                <div
                                    className="p-3 bg-white h-100"
                                    style={{
                                        borderRadius: '4px',
                                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                        border: '1px solid #eaeaea',
                                        transition: 'transform 0.3s ease'
                                    }}
                                >
                                    <div style={{ width: '100%', height: '240px', overflow: 'hidden' }}>
                                        <img
                                            src={`${backendBaseUrl}${gallery?.image}`}
                                            alt=""
                                            onClick={() => {
                                                setSelectedImage(`${backendBaseUrl}${gallery?.image}`);
                                                setSelectedCaption(gallery?.caption || '');
                                            }}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                cursor: 'pointer',
                                                borderRadius: '2px'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {selectedImage && (
                <div style={styles.modalOverlay} onClick={() => setSelectedImage(null)}>
                    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <span
                            style={styles.closeButton}
                            onClick={() => {
                                setSelectedImage(null);
                                setSelectedCaption('');
                            }}
                        >
                            &times;
                        </span>
                        <div style={styles.imageWrapper}>
                            <img src={selectedImage} alt="Full View" style={styles.modalImage} />
                        </div>
                        {selectedCaption && (
                            <div className="p-3 bg-white text-center">
                                <p className="mb-0 text-dark fw-semibold" style={{ fontSize: '15px' }}>
                                    {selectedCaption}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default GalleryCard;